import { render, staticRenderFns } from "./AwsSaffronReport.vue?vue&type=template&id=3c44fe3e&"
import script from "./AwsSaffronReport.vue?vue&type=script&lang=js&"
export * from "./AwsSaffronReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports